<script lang="ts">
  import { COMPANY_ADDRESS, COMPANY_CONTACT_PHONES, COMPANY_EMAIL, COMPANY_WEB_LINK } from '$lib/constants'
  import { locale, localizeUrl, t } from '$lib/translations'
  import { Facebook, Instagram, Youtube } from 'lucide-svelte'
  import { twMerge } from 'tailwind-merge'
  import { ISLANDS } from '$lib/constants'

  const islandsOfficesToShow = ISLANDS.filter(({ short }) => !['EH', 'LG'].includes(short))
  const islandsInfo = islandsOfficesToShow.map(({ long, short }) => ({
    name: long,
    short,
    href: `/airports/${long.toLowerCase()}.pdf`
  }))
  let classes = ''
  export { classes as class }

  let navInfoItems = [
    { path: '/general-info', label: $t('common.general_info'), newTab: false },
    { path: `/legal/${$t('info.legal_information_pdf')}`, label: $t('common.legal_info'), newTab: true },
    { path: `/legal/${$t('info.cookies_pdf')}`, label: $t('common.cookies_policy'), newTab: true },
    { path: `/legal/${$t('info.general_terms_pdf')}`, label: $t('common.general_conditions'), newTab: true },
    { path: `/legal/${$t('info.privacy_pdf')}`, label: $t('common.privacy_info'), newTab: true },
    { path: '/complains', label: $t('common.complaints_and_claims'), newTab: false },
    { path: '/lost-and-founds', label: $t('common.lost_and_found_goods'), newTab: false }
  ]

  navInfoItems = navInfoItems.map(i => ({ ...i, path: i.newTab ? i.path : localizeUrl(i.path, locale.get()).toString() }))
</script>

<footer >
  <div class={twMerge('bg-[#333333] text-center md:text-left flex flex-col md:flex-row gap-5 justify-around py-10 md:px-44 truncate footer-info', classes)}>
    <div id="information-section">
      <h1>{$t('common.information')}</h1>
      <ul>
        {#each navInfoItems as item}
          <!-- eslint-disable-next-line svelte/no-at-html-tags -->
          <li><a href={item.path} target={item.newTab ? '_blank' : '_self'}>{@html item.label}</a></li>
        {/each}
      </ul>
    </div>
    <div id="help-section">
      <h1>{$t('common.help')}</h1>
      <ul>
        <li><a href={localizeUrl('/how-to-book', locale.get()).toString()}>{$t('info.how_to_book')}</a></li>
        <li><a href={localizeUrl('/', locale.get()).toString()}>{$t('info.manage_booking')}</a></li>
      </ul>
    </div>
    <div id="offices-section">
      <h1>{$t('common.our_offices')}</h1>
      <ul>
        {#each islandsInfo as island}
          {#if island.short == 'TF'}
            <li><a href={'/airports/tenerife_sur.pdf'}
              target="_blank"
              rel="noopener noreferrer"
              >{island.name} ({$t('info.airport_tfs')})</a></li>
            <li><a
              href={'/airports/tenerife_norte.pdf'}
              target="_blank"
              rel="noopener noreferrer"
              >{island.name} ({$t('info.airport_tfn')})</a
            ></li>
          {:else}
            <li><a href={island.href} target="_blank" rel="noopener noreferrer">{island.name}</a></li>
          {/if}
        {/each}
      </ul>
    </div>
    <div id="contact-section">
      <h1>{$t('common.contact')}</h1>
      <ul>
        <li>{COMPANY_ADDRESS}</li>
        <li>{$t('contact.address_info_cs')}</li>
        <li>{COMPANY_CONTACT_PHONES}</li>
        <li><a href={`mailto:${COMPANY_EMAIL}`}>{COMPANY_EMAIL}</a></li>
        <li><a href={`//${COMPANY_WEB_LINK}`}>{COMPANY_WEB_LINK}</a></li>
        <li class="flex flex-row gap-1 mt-2 justify-center md:justify-start">
          <a href="https://www.instagram.com/canaryshuttle/" target="_blank">
            <Instagram />
          </a>
          <a href="https://www.facebook.com/canaryshuttle/" target="_blank">
            <Facebook />
          </a>
          <a href="https://www.youtube.com/@Grupo_1844" target="_blank">
            <Youtube />
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div class="bg-[#333333] text-center md:text-left">
    <img src="/footer.png" alt="" class="mx-auto lg:w-[40vw]">
  </div>
</footer>

<style lang="postcss">
  .footer-info > div > h1 {
    @apply text-cs-light-yellow text-xl mb-4;
  }

  .footer-info li {
    @apply text-white text-sm;
  }

  #information-section li, #help-section li {
    @apply hover:underline;
  }
</style>